var moment = require('moment');
var pikaday = require('pikaday');

export default {
	init() {
		let minDate = new Date();
		let selector = document.querySelector('.js-datetimepicker');
		let format = selector.dataset.format;

		let options = { 
			field: selector,
			format: 'DD-MM-YYYY',
			yearRange: [1920, minDate.getFullYear()]
		};

		if (typeof format !== 'undefined') {
			options['format'] = format;
		}

		var picker = new pikaday(options);
	}
}